module.exports = __webpack_public_path__ + "media/icons/left-right-arrow-2bf60b5c.svg";